
import { useState, useEffect } from "react";
import { Market } from "./marketData";

interface UseMarketSelectionProps {
  currentDefaultMarket: string;
  currentActiveMarkets: string[];
  open: boolean;
}

export const useMarketSelection = ({
  currentDefaultMarket,
  currentActiveMarkets,
  open
}: UseMarketSelectionProps) => {
  const [selectedMarkets, setSelectedMarkets] = useState<string[]>([currentDefaultMarket]);
  const [defaultMarket, setDefaultMarket] = useState<string>(currentDefaultMarket);
  const [activeMarkets, setActiveMarkets] = useState<string[]>(currentActiveMarkets);
  
  // Reset selected markets when dialog opens
  useEffect(() => {
    if (open) {
      setSelectedMarkets([currentDefaultMarket, ...currentActiveMarkets.filter(m => m !== currentDefaultMarket)]);
      setDefaultMarket(currentDefaultMarket);
      setActiveMarkets(currentActiveMarkets);
    }
  }, [open, currentDefaultMarket, currentActiveMarkets]);

  const handleCheckboxChange = (country: string, checked: boolean) => {
    if (checked) {
      setSelectedMarkets((prev) => [...prev, country]);
    } else {
      setSelectedMarkets((prev) => prev.filter((c) => c !== country));
      // If the default market is unchecked, reset the default
      if (country === defaultMarket) {
        setDefaultMarket("");
      }
      // Remove from active markets if unchecked
      setActiveMarkets(prev => prev.filter(c => c !== country));
    }
  };

  const handleDefaultChange = (country: string, checked: boolean) => {
    if (checked) {
      setDefaultMarket(country);
    } else if (country === defaultMarket) {
      setDefaultMarket("");
    }
  };

  const handleActiveChange = (country: string, checked: boolean) => {
    if (checked) {
      setActiveMarkets(prev => [...prev, country]);
    } else {
      setActiveMarkets(prev => prev.filter(c => c !== country));
    }
  };

  return {
    selectedMarkets,
    defaultMarket,
    activeMarkets,
    handleCheckboxChange,
    handleDefaultChange,
    handleActiveChange
  };
};
